import { TransactionSortOption } from "@syla/shared/types/requests/GetGroupsRequest";
import React from "react";
import { StandardSelectOption } from "../../../selector/parts/SelectOption";
import {
  SingleSelector,
  SingleSelectProps,
} from "../../../selector/SingleSelector";

type SortBySelectorProps = {
  value: TransactionSortOption;
  onChange: (selection: TransactionSortOption) => void;
} & Omit<
  SingleSelectProps<string>,
  "options" | "placeholder" | "value" | "onChange" | "enableDeselect"
>;

export function SortBySelector({
  value,
  onChange,
  ...props
}: SortBySelectorProps): React.ReactElement {
  return (
    <SingleSelector
      enableDeselect={false}
      value={value}
      onChange={onChange}
      placeholder="Sort by"
      options={SortByOptions}
      {...props}
    />
  );
}

const OrderSortOptionLabels: Record<TransactionSortOption, string> = {
  [TransactionSortOption.DateAscending]: "Sort oldest first",
  [TransactionSortOption.DateDescending]: "Sort newest first",
};

const SortByOptions: StandardSelectOption<TransactionSortOption>[] =
  Object.values(TransactionSortOption).map((value) => ({
    value,
    data: {
      label: OrderSortOptionLabels[value],
    },
  }));
